/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateLinearAcceleratorDtoSourceAxisDistance } from './CreateLinearAcceleratorDtoSourceAxisDistance';
import {
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON,
    CreateLinearAcceleratorDtoSourceAxisDistanceFromJSONTyped,
    CreateLinearAcceleratorDtoSourceAxisDistanceToJSON,
} from './CreateLinearAcceleratorDtoSourceAxisDistance';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemBeamLimitingDeviceType } from './MedicalSystemBeamLimitingDeviceType';
import {
    MedicalSystemBeamLimitingDeviceTypeFromJSON,
    MedicalSystemBeamLimitingDeviceTypeFromJSONTyped,
    MedicalSystemBeamLimitingDeviceTypeToJSON,
} from './MedicalSystemBeamLimitingDeviceType';
import type { MedicalSystemBeamProduction } from './MedicalSystemBeamProduction';
import {
    MedicalSystemBeamProductionFromJSON,
    MedicalSystemBeamProductionFromJSONTyped,
    MedicalSystemBeamProductionToJSON,
} from './MedicalSystemBeamProduction';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { NullableOneOfPropertyOfStorageLocation } from './NullableOneOfPropertyOfStorageLocation';
import {
    NullableOneOfPropertyOfStorageLocationFromJSON,
    NullableOneOfPropertyOfStorageLocationFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationToJSON,
} from './NullableOneOfPropertyOfStorageLocation';
import type { OneOfPropertyOfPtw100InternalArea } from './OneOfPropertyOfPtw100InternalArea';
import {
    OneOfPropertyOfPtw100InternalAreaFromJSON,
    OneOfPropertyOfPtw100InternalAreaFromJSONTyped,
    OneOfPropertyOfPtw100InternalAreaToJSON,
} from './OneOfPropertyOfPtw100InternalArea';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface OtherMvTherapyMachineDto
 */
export interface OtherMvTherapyMachineDto {
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMvTherapyMachineDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMvTherapyMachineDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMvTherapyMachineDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof OtherMvTherapyMachineDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherMvTherapyMachineDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherMvTherapyMachineDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherMvTherapyMachineDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof OtherMvTherapyMachineDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof OtherMvTherapyMachineDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMvTherapyMachineDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof OtherMvTherapyMachineDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMvTherapyMachineDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof OtherMvTherapyMachineDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof OtherMvTherapyMachineDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherMvTherapyMachineDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    typeId?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof OtherMvTherapyMachineDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {StateOfUse}
     * @memberof OtherMvTherapyMachineDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {MedicalSystemBeamLimitingDeviceType}
     * @memberof OtherMvTherapyMachineDto
     */
    beamLimitingDeviceType?: MedicalSystemBeamLimitingDeviceType;
    /**
     * 
     * @type {MedicalSystemBeamProduction}
     * @memberof OtherMvTherapyMachineDto
     */
    beamProduction?: MedicalSystemBeamProduction;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {CreateLinearAcceleratorDtoSourceAxisDistance}
     * @memberof OtherMvTherapyMachineDto
     */
    sourceAxisDistance?: CreateLinearAcceleratorDtoSourceAxisDistance | null;
    /**
     * 
     * @type {NullableOneOfPropertyOfStorageLocation}
     * @memberof OtherMvTherapyMachineDto
     */
    imageLocation?: NullableOneOfPropertyOfStorageLocation;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    externalRtSystemId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    externalFileSystemPath?: string | null;
    /**
     * 
     * @type {OneOfPropertyOfPtw100InternalArea}
     * @memberof OtherMvTherapyMachineDto
     */
    ptw100AreaName?: OneOfPropertyOfPtw100InternalArea;
    /**
     * 
     * @type {string}
     * @memberof OtherMvTherapyMachineDto
     */
    $type?: OtherMvTherapyMachineDtoTypeEnum;
}


/**
 * @export
 */
export const OtherMvTherapyMachineDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsOtherMvTherapyMachineDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.OtherMvTherapyMachineDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type OtherMvTherapyMachineDtoTypeEnum = typeof OtherMvTherapyMachineDtoTypeEnum[keyof typeof OtherMvTherapyMachineDtoTypeEnum];


/**
 * Check if a given object implements the OtherMvTherapyMachineDto interface.
 */
export function instanceOfOtherMvTherapyMachineDto(value?: unknown): value is OtherMvTherapyMachineDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(OtherMvTherapyMachineDtoTypeEnum)[0];
}

export function OtherMvTherapyMachineDtoFromJSON(json: any): OtherMvTherapyMachineDto {
    return OtherMvTherapyMachineDtoFromJSONTyped(json, false);
}

export function OtherMvTherapyMachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherMvTherapyMachineDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'typeId': !exists(json, 'typeId') ? undefined : json['typeId'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'beamLimitingDeviceType': !exists(json, 'beamLimitingDeviceType') ? undefined : MedicalSystemBeamLimitingDeviceTypeFromJSON(json['beamLimitingDeviceType']),
        'beamProduction': !exists(json, 'beamProduction') ? undefined : MedicalSystemBeamProductionFromJSON(json['beamProduction']),
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'sourceAxisDistance': !exists(json, 'sourceAxisDistance') ? undefined : CreateLinearAcceleratorDtoSourceAxisDistanceFromJSON(json['sourceAxisDistance']),
        'imageLocation': !exists(json, 'imageLocation') ? undefined : NullableOneOfPropertyOfStorageLocationFromJSON(json['imageLocation']),
        'externalRtSystemId': !exists(json, 'externalRtSystemId') ? undefined : json['externalRtSystemId'],
        'externalFileSystemPath': !exists(json, 'externalFileSystemPath') ? undefined : json['externalFileSystemPath'],
        'ptw100AreaName': !exists(json, 'ptw100AreaName') ? undefined : OneOfPropertyOfPtw100InternalAreaFromJSON(json['ptw100AreaName']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function OtherMvTherapyMachineDtoToJSON(value?: OtherMvTherapyMachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'typeId': value.typeId,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'state': StateOfUseToJSON(value.state),
        'beamLimitingDeviceType': MedicalSystemBeamLimitingDeviceTypeToJSON(value.beamLimitingDeviceType),
        'beamProduction': MedicalSystemBeamProductionToJSON(value.beamProduction),
        'serialNumber': value.serialNumber,
        'sourceAxisDistance': CreateLinearAcceleratorDtoSourceAxisDistanceToJSON(value.sourceAxisDistance),
        'imageLocation': NullableOneOfPropertyOfStorageLocationToJSON(value.imageLocation),
        'externalRtSystemId': value.externalRtSystemId,
        'externalFileSystemPath': value.externalFileSystemPath,
        'ptw100AreaName': OneOfPropertyOfPtw100InternalAreaToJSON(value.ptw100AreaName),
        '$type': value.$type,
    });
}

